<template>
  <div class="starred-deck-card">
    <div class="deck-header">
      <div class="deck-icon">
        <i class="el-icon-star-on" style="font-weight: bold; color: #F7BA2A;"></i>
        <span>Starred Course</span>
        <span class="dot">•</span>
        <span class="author-wrapper">
          <span class="author-label">by</span>
          <el-avatar :size="16" :src="starredDeck.deck.user_avatar_address_small" class="author-avatar" style="font-size: 10px;">{{ starredDeck.deck.user_name?.charAt(0) || 'U' }}</el-avatar>
          <span class="author-name">{{ starredDeck.deck.user_name }}</span>
        </span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="deck-actions">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="viewDeck"
          class="view-btn"
        >
          View Course
        </el-button>
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="unstar">
              <i class="el-icon-star-off"></i> Unstar
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="deck-content">
      <div class="deck-preview">
        <h3 class="deck-title" @click="viewDeck">{{ starredDeck.deck.title }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarredDeckCard',
  props: {
    starredDeck: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimestamp() {
      const date = new Date(this.starredDeck.timestamp)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))
      const diffInDays = Math.floor(diffInHours / 24)

      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else if (diffInDays <= 10) {
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
      } else {
        const month = date.toLocaleString('en-US', { month: 'short' })
        const day = date.getDate()
        const year = date.getFullYear()
        const currentYear = now.getFullYear()

        if (year === currentYear) {
          return `${month} ${day}`
        } else {
          return `${month} ${day}, ${year}`
        }
      }
    }
  },
  methods: {
    viewDeck() {
      this.$emit('view', this.starredDeck.deck.id)
    },
    handleCommand(command) {
      if (command === 'unstar') {
        this.$emit('unstar', this.starredDeck.deck.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.starred-deck-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #F7BA2A;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.deck-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.deck-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #F7BA2A;
  }

  > span {
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .author-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;

    .author-label {
      font-size: 12px;
    }

    .author-avatar {
      flex-shrink: 0;
    }

    .author-name {
      font-size: 12px;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.deck-actions {
  display: flex;
  gap: 8px;

  .view-btn {
    color: #F7BA2A;
    font-size: 12px;

    &:hover {
      color: #e6a023;
    }
  }
}

.deck-content {
  .deck-preview {
    .deck-title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
      cursor: pointer;
      line-height: 1.3;
      word-wrap: normal;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;

      &:hover {
        color: #F7BA2A;
      }
    }
  }
}
</style>
